import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { industryLabels } from "@components/entity/constants";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { pluralize } from "@common/helpers/string";
import { EntityProfileIndustry } from "@common/types/entity";
import type { ApplyCoaTemplateEntitySelectionRow } from "../applyCoaTemplateEntitySelection.types";

function buildIndustriesLabel(industries: EntityProfileIndustry[]): string {
    if (industries.length === 0) {
        return "-";
    }
    if (industries.length === 1) {
        return industryLabels[industries[0]] ?? industries[0];
    }
    return `${industries.length} ${pluralize("industry", industries.length)}`;
}

export const ApplyCoaEntityIndustriesCell = memo(
    ({
        row,
    }: CellContext<
        ViewTableFeatures,
        ApplyCoaTemplateEntitySelectionRow,
        unknown
    >) => {
        if (row.original.isClientRow) {
            return <ViewTableCell />;
        }

        const { industries } = row.original;
        const label = buildIndustriesLabel(industries);

        return (
            <ViewTableCell>
                <span className="text-secondary">{label}</span>
            </ViewTableCell>
        );
    },
);
